import { Injectable } from '@angular/core';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root',
})
export class TimeService {
  /**
   * Convert utc time to local with format 'Nov 23, 2022 12:00 PM'
   */
  convertTimeTolll(utctime) {
    return moment(utctime).local().format('lll');
  }

  /**
   * Convert utc time to local with format 'Nov 23, 2022'
   */
  convertTimeToll(utctime) {
    return moment(utctime).local().format('ll');
  }
  /**
   * Get last days utc time with h,m,s to 0
   */
  getLastDayUtcTime(type, number) {
    return moment()
      .hours(0)
      .minutes(0)
      .seconds(59)
      .utc()
      .subtract(number, type)
      .format('YYYY-MM-DD[T]HH:mm:ss[Z]');
  }

  getCurrentUTCTime() {
    return moment.utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]');
  }

  /**
   * Convert given date to utc
   */
  getDateTimeUTcTZFormat(time) {
    return moment(time).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]');
  }

  /** Convert user details date/time to UTC format for payload body */
  convertUserDetailsToUTC(userDetails) {
    userDetails.created_at &&
      (userDetails['created_at'] = this.getDateTimeUTcTZFormat(userDetails.created_at));
    userDetails.last_login &&
      (userDetails['last_login'] = this.getDateTimeUTcTZFormat(userDetails.last_login));
    userDetails.updated_at &&
      (userDetails['updated_at'] = this.getDateTimeUTcTZFormat(userDetails.updated_at));
    userDetails.multifactor_last_modified &&
      (userDetails['multifactor_last_modified'] = this.getDateTimeUTcTZFormat(
        userDetails.multifactor_last_modified
      ));
    return userDetails;
  }
}
